import { PlayerFeedbackSearchTimeType } from '@golden/gdk-admin'
import TKeyType from '../../i18ns/admin/TKeyType'

const playerFeedbackSearchTimeName: { [key in PlayerFeedbackSearchTimeType]: TKeyType } = {
  [PlayerFeedbackSearchTimeType.CREATED_AT]: 'common.generatedAt',
  [PlayerFeedbackSearchTimeType.UPDATED_AT]: 'common.updatedAt'
}

export default playerFeedbackSearchTimeName
